/**
 * ### Related UI components:
 * - [[ContractClausesFormComponent]]
 * 
 * Seeder PHP: ProductContractClausesSeeder
 */
export class ContractClause {
  /** Flag to indicate the API that this Clause must be removed. */
  readonly delete: boolean;
  /**
   * Whether this Clause can be edited by user or not.
   */
  readonly editable: boolean;
  readonly negotiable: boolean;
  readonly removable: boolean;

  readonly id: number;
  readonly order: number;

  readonly alignment: 'top' | 'left' | 'right' | 'bottom';
  /** Conditions to evaluate whether this Clause should be included or not. */
  readonly conditions: string;
  /** Clause text, it could include wildcards. */
  readonly text: string;
  /** Clause title. */
  readonly title: string;

  constructor(data: Partial<ContractClause> = {}) {
    Object.assign(this, data);
  }
}
